const COMPONENT_NAME = "InputError";
export {
  COMPONENT_NAME
};
